import { ApiError } from "@eduviaos/shared";

/** Stable BE contract when `require_module("learning")` denies the request. */
export function isModuleDisabledError(err: unknown): boolean {
  return err instanceof ApiError && err.details?.code === "MODULE_DISABLED";
}
